// components/AdminListHoliday/AdminListHoliday.js
import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Button } from '../UI/Button.js';
import { Dropdown } from '../UI/Dropdown.js';
import { FormContainer, FullWidth } from '../../styles/sharedStyles';
import styled from 'styled-components';
import Select from 'react-select'; // Import react-select

const cellStyle = { border: '1px solid #ccc', padding: '8px' };

const AdminListHoliday = () => {
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');
  const [selectedHolidayTypes, setSelectedHolidayType] = useState([]);
  
  const [holidayResults, setHolidayResults] = useState([]);
  const hasNameColumn = holidayResults.some(item => item.holiday_name !== null && item.holiday_name !== undefined);
  
  // Row selection logic  
  const [selectedRows, setSelectedRows] = useState(new Set());
  
  //This const is to generate unique id for each return row
  const normalizeHolidayData = (data) => {
	return data.map(item => ({
		...item,
		id: `${item.holiday_type}_${item.holiday_date}`
	}));
	};
  
  const toggleSelectRow = (id) => {
     setSelectedRows(prev => {
       const newSet = new Set(prev);
       if (newSet.has(id)) {
         newSet.delete(id);
       } else {
         newSet.add(id);
       }
       return newSet;
     });
   };

   const toggleSelectAll = () => {
     if (selectedRows.size === holidayResults.length) {
       setSelectedRows(new Set());
     } else {
       setSelectedRows(new Set(holidayResults.map(item => item.id)));
     }
   };
   
   const isAllSelected = holidayResults.length > 0 && selectedRows.size === holidayResults.length;
  
   const handleDeleteSelected = async () => {
   const idsToDelete = Array.from(selectedRows);
   const holidaysToDelete = holidayResults.filter(item => selectedRows.has(item.id));
      try {
			 const response = await api.post('/delete-holidays', { holidays: holidaysToDelete });
			 setHolidayResults(prev => prev.filter(item => !selectedRows.has(item.id)));
			 setSelectedRows(new Set());
			 alert(`${response.data.deleted} registros eliminados.`);
		  } catch (err) {
			 console.error('Delete failed', err);
			 alert('Failed to delete selected records');
		  }   
		 }; 

   const handleDeleteOne = async (id) => {
   const item = holidayResults.find(h => h.id === id);
      try {
             const response = await api.post('/delete-holidays', { holidays: [item] });
             setHolidayResults(prev => prev.filter(item => item.id !== id));
             setSelectedRows(prev => {
               const newSet = new Set(prev);
               newSet.delete(id);
               return newSet;
             });
		  alert(`${response.data.deleted} registro eliminado.`);
          } catch (err) {
            console.error('Delete failed', err);
            alert('Failed to delete the record');
          }
         };
  
  //end row selection logic
  const holidayTypesOptions = [
  { value: 'Annual', label: 'Festivo por año' },
  { value: 'Common', label: 'Festivo común' },
];
  
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i); // Last 10 years
  const months = Array.from({ length: 12 }, (_, i) => i + 1); // 1-12
  const isOptionSelected = (option) => {
    return selectedHolidayTypes.some(selected => selected.value === option.value);
  };

  const handleListHoliday = async () => {
  try {
    let url = '/listholidays';
    const params = new URLSearchParams();
    if (year) params.append('year', year); 
    if (month) params.append('month', month);
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
	
	const payload = {
        holiday_types: selectedHolidayTypes.map(option => option.value)
      };

    const response = await api.post(url, payload);
	if (response.data.length === 0) {
      alert('No se encontraron festivos con los filtros seleccionados.');
    }
	setHolidayResults(normalizeHolidayData(response.data));
  } catch (error) {
      console.error('Listing holidays failed', error);
      alert('Listing holidays failed');
	  }
  };
  
  return (
    <div>
      <h2>Lista de festivos</h2>
	  <FormContainer>
      <FullWidth>
          <Dropdown value={year} onChange={(e) => setYear(e.target.value)} >
            <option value="">Año</option>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
        <FullWidth>
          <Dropdown value={month} onChange={(e) => setMonth(e.target.value)} >
            <option value="">Mes</option>
            {months.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
	   <FullWidth>
			<Select
				isMulti
				onChange={(selectedOptions) => setSelectedHolidayType(selectedOptions)}
				placeholder="Selecciona tipo de festivo"
				isOptionSelected={isOptionSelected}
				closeMenuOnSelect={false}
				options={holidayTypesOptions}
			/>
	  </FullWidth>
	  <FullWidth>
      <Button onClick={handleListHoliday}>Mostrar</Button>
	  </FullWidth>
	  </FormContainer>
	  
	  {/* Return table section in a div */}
	  {holidayResults.length > 0 && (
    <div style={{ marginTop: '20px' }}>
    {selectedRows.size > 0 && (
  	<div style={{ marginTop: '10px' }}>
  		<Button onClick={handleDeleteSelected}>
  			Eliminar seleccionados ({selectedRows.size})
  		</Button>
  	</div>
  	)}
    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
      <thead>
		<tr>
		    <th style={cellStyle}>
				<input
					type="checkbox"
					checked={isAllSelected}
					onChange={toggleSelectAll}
				/>
			</th>
			{hasNameColumn && <th style={cellStyle}>Descripción</th>}
			<th style={cellStyle}>Fecha</th>
			<th style={cellStyle}>Tipo</th>
			<th style={cellStyle}></th>
		</tr>
	  </thead>
	  <tbody>
	  {holidayResults.map((item, index) => (
		  <tr key={index}>
		  <td style={{ ...cellStyle, textAlign: 'center' }}>
			<input
				type="checkbox"
				checked={selectedRows.has(item.id)}
				onChange={() => toggleSelectRow(item.id)}
			/>
		  </td>
		  {hasNameColumn && (
			  <td style={cellStyle}>{item.holiday_name || '—'}</td>
		  )}
		  <td style={cellStyle}>
            {new Intl.DateTimeFormat('es-ES', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            }).format(new Date(item.holiday_date))}
          </td>
		  <td style={cellStyle}>
            {
              holidayTypesOptions.find(opt => opt.value === item.holiday_type)?.label || item.holiday_type
            }
          </td>
		  <td style={{ ...cellStyle, textAlign: 'center' }}>
			<button onClick={() => handleDeleteOne(item.id)} title="Eliminar">
				🗑️
			</button>
      </td>
		  </tr>
	  ))}
	 </tbody>
    </table>
  </div>
)}
	  
    </div>
  );
};

export default AdminListHoliday;